export default __webpack_public_path__ + "static/media/40244.135b6bf8.jpg";